export const NAV_ENTERING_TIME = 150
export const NAV_SWITCHING_TIME = 150
export const NAV_EXITING_TIME = 125
export const NAV_DELAY_TIME = 120
export const DESKTOP_COLLAPSED_FLYOUT_HEIGHT = 243
